export const systemMessages = {

  defaultError: 'Sorry, there was an error. Please contact support@flowspeak.io for help.',

  // Record
  tryAgain: 'Sorry, there was an error. Please try again.',
  noSpeech: 'Sorry, we could not hear you. Please try again.',
  isRepeat: 'Please do not repeat the question. Respond with your own answer.',

  // App version
  downloadLatest: 'Please download the latest version of the FLOW Speak app to access that lesson type',

  // Assessment
  summaryError: 'Sorry, there was an error generating the summary.'
}